import { StyleSheet } from "@react-pdf/renderer";
import { blue, lightGray } from "./PDFColors";

export const styles = StyleSheet.create({
  backgroundBlue: {
    height: "100%",
    width: "100%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "10pt",
  },

  timelineContainer: {
    width: "100%",
    height: "30%",
  },

  canvasBox: {
    width: 0,
    height: 0,
  },

  founderCommitmentContainer: {
    width: "100%",
    height: "50%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignContent: "center",
    marginTop: "-90px",
    marginLeft: "-10px",
  },

  founderCommitmentContainerSmallMargin: {
    width: "100%",
    height: "50%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignContent: "center",
    marginTop: "-50px",
    marginLeft: "-10px",
  },

  sideNoteContainer: {
    width: "100%",
    height: "20%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignContent: "center",
    marginLeft: "-10px",
  },

  sideNoteContainerSmallMargin: {
    width: "100%",
    height: "20%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignContent: "center",
    marginTop: "-50px",
    marginLeft: "-10px",
  },

  sideNoteTextBox: {
    width: "70%",
    height: "90%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "2pt",
    paddingHorizontal: "10px",
    paddingVertical: "2px",
    justifyContent: "center",
    backgroundColor: lightGray,
  },

  rolesResponsibilitiesBox: {
    width: "28%",
    height: "30%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
    margin: "15px",
  },
  foundersBox: {
    height: "23%",
    width: "100%",
    borderBottomStyle: "solid",
    borderBottomColor: blue,
    borderBottomWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: blue,
  },
  textFounders: { color: "white", fontSize: "12px" },
  titleBox: {
    height: "23%",
    width: "100%",
    borderBottomStyle: "solid",
    borderBottomColor: blue,
    borderBottomWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
  },
  textTitleBox: { fontSize: "12px" },

  commitmentBox: {
    width: "100%",
    height: "54%",
    textAlign: "center",
    justifyContent: "center",
    alignContent: "center",
    display: "flex",
    flexDirection: "column",
  },

  textCommitmentBox: {
    textAlign: "center",
    fontSize: "13px",
    marginVertical: "2px",
  },

  textSideNoteTextBox: {
    textAlign: "justify",
    fontSize: "15px",
  },
});
